const RARITIES = ['common', 'rare', 'epic', 'legendary'];

function getOrderAbilities(order) {
  if (Array.isArray(order?.abilities)) return order.abilities;
  if (typeof order?.ability === 'string') return [order.ability];
  if (Array.isArray(order?.abilitiesList)) return order.abilitiesList;
  return [];
}

/** Aggregate strategy order stats (War Effort attack strategy / Strategy builder details). */
export function computeAttackStrategyStatistics(orders) {
  const list = Array.isArray(orders) ? orders : [];
  const costCounts = [...Array(13).keys()].map(() => 0);
  const rarityCounts = { common: 0, rare: 0, epic: 0, legendary: 0 };
  const factionCounts = {};
  const abilityCounts = {};
  let units = 0;
  let drones = 0;
  let weapons = 0;
  let stratagems = 0;

  list.forEach((order) => {
    if (!order) return;
    const c = order.cost ?? order.intel_cost ?? 0;
    if (typeof c === 'number' && c >= 0 && c <= 12) costCounts[Math.floor(c)] += 1;
    const r = (order.rarity || 'common').toString().toLowerCase();
    if (rarityCounts[r] !== undefined) rarityCounts[r] += 1;
    else rarityCounts.common += 1;
    const factionName = order.faction_name || order.faction || 'Unknown';
    factionCounts[factionName] = (factionCounts[factionName] || 0) + 1;
    const orderType = (order.type || '').toLowerCase();
    if (orderType === 'drone') drones += 1;
    else if (orderType === 'weapon') weapons += 1;
    else if (orderType === 'strategem' || orderType === 'stratagem') stratagems += 1;
    else units += 1;
    getOrderAbilities(order).forEach((abilityName) => {
      const key = (abilityName || '').trim();
      if (key) abilityCounts[key] = (abilityCounts[key] || 0) + 1;
    });
  });

  const abilityEntries = Object.entries(abilityCounts).sort((a, b) => b[1] - a[1]);
  const factionEntries = Object.entries(factionCounts).sort((a, b) => b[1] - a[1]);
  const maxCostCount = Math.max(...costCounts, 1);
  const maxRarityCount = Math.max(...Object.values(rarityCounts), 1);

  return {
    costCounts,
    rarityCounts,
    factionEntries,
    abilityEntries,
    units,
    drones,
    weapons,
    stratagems,
    maxCostCount,
    maxRarityCount,
    RARITIES,
  };
}

const FACTION_COLORS_STRATEGY = {
  'Remnants of Humanity': '#556B2F',
  'Exolot Dominion': '#4B0082',
  'League of Shadows': '#1A1A1A',
  "Ra's Children": '#F4A460',
  Asrah: '#8B0000',
  'The Sentients': '#ADD8E6',
  Combined: '#FFA500',
};

const COMBINED_FACTIONS_STRATEGY = {
  'The Conspiracy': true,
  'The Corrupted Core': true,
  'The Covenant': true,
  'The Divine Syndicate': true,
  'The Forsaken Pact': true,
  'The Hollow': true,
  'The Iron Alliance': true,
  'The Last Crusade': true,
  'The Shadow Consortium': true,
  'The Silent Accord': true,
};

export function getAttackStrategyFactionRowColor(factionName) {
  if (!factionName || factionName === 'Unknown') return '#ccc';
  if (COMBINED_FACTIONS_STRATEGY[factionName]) return FACTION_COLORS_STRATEGY.Combined;
  return FACTION_COLORS_STRATEGY[factionName] || '#FFFFFF';
}

/** Orders included in attack-strategy stats (excludes deactivated slots). */
export function getActiveAttackStrategyOrders(strategyOrders, deactivatedSlots) {
  const deactivatedSet = new Set(deactivatedSlots || []);
  const slots = (strategyOrders || []).flatMap((order) =>
    Array.from({ length: order.count || 1 }, (_, j) => ({
      order,
      orderId: order.id ?? order.order_id,
      occurrence: j,
    }))
  );
  return slots
    .filter((s) => !deactivatedSet.has(`${s.orderId}:${s.occurrence}`))
    .map((s) => s.order);
}

export const ATTACK_STRATEGY_PANEL_BOX_STYLE = {
  width: 400,
  minWidth: 400,
  background: '#1a1a1a',
  borderRadius: 12,
  border: '1px solid rgba(255,255,255,0.15)',
  padding: 20,
  pointerEvents: 'auto',
  boxSizing: 'border-box',
};
